import { api } from '../middleware/api';

export interface AmCategory {
  ct_id: number;
  ct_company: string;
  ct_name: string;
  ct_depmethod?: string;
  ct_deprate?: number;
  ct_uid?: string;
  ct_cdt?: string;
  ct_muid?: string;
  ct_mdt?: string;
}

export const amcategoryApi = api
  .enhanceEndpoints({ addTagTypes: ['AmCategory'] })
  .injectEndpoints({
    endpoints: builder => ({
      getAmCategories: builder.query<AmCategory[], string>({
        query: (company) => `amcategory?company=${company}`,
        providesTags: ['AmCategory']
      }),
      getAmCategoryById: builder.query<AmCategory, number>({
        query: (id) => `amcategory/byid/${id}`,
        providesTags: ['AmCategory']
      }),
      insertAmCategory: builder.mutation<{ ct_id: number }, AmCategory>({
        query: (body) => ({
          url: 'amcategory',
          method: 'POST',
          body
        }),
        invalidatesTags: ['AmCategory']
      }),
      updateAmCategory: builder.mutation<{ ct_id: number }, AmCategory>({
        query: (body) => ({
          url: 'amcategory',
          method: 'POST',
          body
        }),
        invalidatesTags: ['AmCategory']
      }),
      deleteAmCategory: builder.mutation<{ message: string }, number>({
        query: (id) => ({
          url: `amcategory/${id}`,
          method: 'DELETE'
        }),
        invalidatesTags: ['AmCategory']
      })
    }),
    overrideExisting: false
  });

export const {
  useGetAmCategoriesQuery,
  useGetAmCategoryByIdQuery,
  useInsertAmCategoryMutation,
  useUpdateAmCategoryMutation,
  useDeleteAmCategoryMutation
} = amcategoryApi;
